module.exports = __webpack_public_path__ + "img/icon-03.8141e68d.png";